import React from 'react';
// @ts-ignore:next-line
import { AppIcon } from '@folio/stripes/core';
export var ListAppIcon = function () {
    return React.createElement(AppIcon, { app: "@folio/lists", iconKey: "app", size: "small" });
};
